// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"462":"1d152e09","842":"e73ddd86"}[chunkId] + ".chunk.js";
};